import React from 'react';
import Icon from '../../../components/AppIcon';

const ROIOverview = ({ analytics }) => {
  if (!analytics) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {[1, 2, 3, 4]?.map((i) => (
          <div key={i} className="bg-card border border-border rounded-lg p-6 animate-pulse">
            <div className="h-12 bg-muted rounded mb-4"></div>
            <div className="h-6 bg-muted rounded mb-2"></div>
            <div className="h-4 bg-muted rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  const { totalValue, totalCost, portfolioROI, unrealizedGains, totalItems } = analytics;

  const metrics = [
    {
      label: 'Total Portfolio Value',
      value: `$${totalValue?.toLocaleString()}`,
      icon: 'DollarSign',
      iconBg: 'bg-primary/10',
      iconColor: 'text-primary',
      subtext: `Cost basis: $${totalCost?.toLocaleString()}`
    },
    {
      label: 'Portfolio ROI',
      value: `${portfolioROI >= 0 ? '+' : ''}${portfolioROI?.toFixed(2)}%`,
      icon: portfolioROI >= 0 ? 'TrendingUp' : 'TrendingDown',
      iconBg: portfolioROI >= 0 ? 'bg-success/10' : 'bg-destructive/10',
      iconColor: portfolioROI >= 0 ? 'text-success' : 'text-destructive',
      subtext: 'Return on investment',
      trend: portfolioROI
    },
    {
      label: 'Unrealized Gains',
      value: `${unrealizedGains >= 0 ? '+' : ''}$${Math.abs(unrealizedGains)?.toLocaleString()}`,
      icon: unrealizedGains >= 0 ? 'ArrowUp' : 'ArrowDown',
      iconBg: unrealizedGains >= 0 ? 'bg-success/10' : 'bg-destructive/10',
      iconColor: unrealizedGains >= 0 ? 'text-success' : 'text-destructive',
      subtext: 'Total gain/loss',
      trend: unrealizedGains
    },
    {
      label: 'Total Items',
      value: totalItems?.toLocaleString(),
      icon: 'Package',
      iconBg: 'bg-conversion-accent/10',
      iconColor: 'text-conversion-accent',
      subtext: `Avg value: $${totalItems > 0 ? (totalValue / totalItems)?.toFixed(0) : 0}`
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {metrics?.map((metric, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6 premium-hover">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 ${metric?.iconBg} rounded-lg flex items-center justify-center`}>
              <Icon name={metric?.icon} size={24} className={metric?.iconColor} />
            </div>
            {metric?.trend !== undefined && (
              <div className={`text-sm font-medium ${
                metric?.trend >= 0 ? 'text-success' : 'text-destructive'
              }`}>
                {metric?.trend >= 0 ? '↑' : '↓'}
              </div>
            )}
          </div>
          <div className="text-2xl font-bold text-card-foreground mb-1">
            {metric?.value}
          </div>
          <div className="text-sm text-muted-foreground mb-1">{metric?.label}</div>
          <div className="text-xs text-muted-foreground">{metric?.subtext}</div>
        </div>
      ))}
    </div>
  );
};

export default ROIOverview;